/* eslint-disable react/no-danger */
import React, { useState, useRef, useEffect, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import styles from './styles.module.css';
import { Checkbox, CircularProgress, Popover } from '@mui/material';
import Spinner from 'components/shared/Spinner';
import {
  keyboard,
  scribble,
  fsfLogo,
  caretDoubleDown,
  warningCircle,
} from 'assets/newIcons';
import SignatureCanvas from 'react-signature-canvas';
import Dialog from '@material-ui/core/Dialog';
import MobileContext from 'context/MobileContext';
import SmallMobileContext from 'context/SmallMobileContext';

const PolicyScreen = ({
  loadPolicyDetails,
  isPolicyDetailsLoading,
  policyDetails,
  loadIpAddress,
  ipAddress,
  handleSignIn,
  isSignInloading,
  signInData,
}) => {
  const location = useLocation();
  const history = useHistory();
  const portalUrl = process.env.REACT_APP_MEMBER_PORTAL_URL;
  const isMobile = useContext(MobileContext);
  const isSmallMobile = useContext(SmallMobileContext);
  const [isTabsEnabled, setIsTabsEnabled] = useState(false);
  const scrollContainerRef = useRef(null);
  const checkboxRef = useRef(null);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [openThanksDialog, setOpenThanksDialog] = useState(false);
  const [activeTab, setActiveTab] = useState('type');
  const [typedSignature, setTypedSignature] = useState('');
  const [typedSignImage, setTypedSignImage] = useState(null);
  const offscreenCanvasRef = useRef(null);
  const typesSignatureBoxRef = useRef(null);
  const signedCanvasRef = useRef(null);
  const [drawSignImage, setDrawSignImage] = useState(null);
  const [forceRender, setForceRender] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const caId = queryParams.get('code');
  const TermsAndConditionsId = queryParams.get('documentId');
  const source = queryParams.get('source');
  const url = window.location.href;
  const { firstName, lastName, hsId } = policyDetails;
  const termsAndConditionsId = policyDetails?.termsAndConditionsId;
  const [isSignClicked, setIsSignClicked] = useState(false);
  const [openCheckboxDialog, setOpenCheckboxDialog] = useState(false);
  const [openScrollGuidanceBubble, setOpenScrollGuidanceBubble] = useState(true);
  const checkboxContainerRef = useRef(null);
  const dialogRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleScroll = () => {
    const scrollContainer = scrollContainerRef.current;
    const scrolledToBottom =
      scrollContainer.scrollHeight - scrollContainer.scrollTop - 10 <
      scrollContainer.clientHeight;
    setIsScrolledToBottom(scrolledToBottom);
  };

  const handleCheckboxClick = event => {
    if (!isScrolledToBottom && !isTabsEnabled) {
      event.preventDefault();
      setAnchorEl(event.currentTarget);
    }
  };

  const handleCheckboxChange = event => {
    if (isScrolledToBottom) {
      const isChecked = event.target.checked;
      setIsTabsEnabled(isChecked);

      if (!isChecked) {
        setActiveTab('type');
      }
    }
  };

  // Close popover when scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (anchorEl) {
        setAnchorEl(null);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [anchorEl]);

  const handleSignature = event => {
    setTypedSignature(event.target.value);
    setForceRender(!forceRender);
  };

  const handleClear = () => {
    if (activeTab === 'type') {
      setTypedSignature('');
    } else {
      signedCanvasRef.current.clear();
      setDrawSignImage(null);
    }
  };

  const handleSignInClick = () => {
    setIsSignClicked(true);
    const formData = new FormData();
    formData.append('CaId', caId);
    formData.append('HubSpotId', hsId);
    formData.append('documentId', TermsAndConditionsId);
    formData.append('useripaddress', ipAddress);
    formData.append('documnetUrl', url);
    if (activeTab === 'type') {
      const base64Data = typedSignImage.replace(
        /^data:image\/(png|jpg|jpeg);base64,/,
        ''
      );
      const binaryString = window.atob(base64Data);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: 'image/png' });

      // Append signature as file
      formData.append('esignuser', blob, 'typed-signature.png');
      handleSignIn(formData);
    } else {
      const base64Data = drawSignImage.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
      const binaryString = window.atob(base64Data);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: 'image/png' });

      // Append signature as file
      formData.append('esignuser', blob, 'draw-signature.png');
      handleSignIn(formData);
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (policyDetails && policyDetails?.isSign) {
      history.push('/');
    }
  }, [policyDetails]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setOpenScrollGuidanceBubble(false);
    }, 5000);
    // Construct the params object
    const params = { caId, TermsAndConditionsId, source };
    // Dispatch the action to fetch policy details
    if (caId && source && TermsAndConditionsId) {
      loadPolicyDetails(params);
      loadIpAddress();
    }
  }, []);

  useEffect(() => {
    if (Object.keys(signInData).length !== 0 && signInData?.success) {
      setOpenThanksDialog(true);
    }
  }, [signInData]);

  useEffect(() => {
    if (typedSignature) {
      const offscreenCanvas = offscreenCanvasRef.current;
      offscreenCanvas.width = 800;
      const context = offscreenCanvas.getContext('2d');

      const typesSignatureBox = typesSignatureBoxRef.current;
      const computedStyle = window.getComputedStyle(typesSignatureBox);

      // Get computed styles
      const fontFamily = computedStyle.fontFamily;
      let fontSize = parseFloat(computedStyle.fontSize); // Convert font size to a number
      fontSize = fontSize * 1.8;
      offscreenCanvas.height = fontSize * 1.8;
      // Set updated font style on canvas
      context.font = `${fontSize}px ${fontFamily}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';

      // Clear previous content
      context.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);

      // Draw the typed signature
      context.fillText(
        typedSignature,
        offscreenCanvas.width / 2,
        offscreenCanvas.height / 2
      );

      // Get the image data
      const typedSignatureImage = offscreenCanvas.toDataURL('image/png');
      setTypedSignImage(typedSignatureImage);
    }
  }, [typedSignature]);

  useEffect(() => {
    if (activeTab === 'draw' && drawSignImage) {
      signedCanvasRef.current.clear();
      setDrawSignImage(null);
    }
  }, [activeTab]);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        dialogRef.current &&
        !dialogRef.current.contains(event.target) &&
        checkboxContainerRef.current &&
        !checkboxContainerRef.current.contains(event.target)
      ) {
        setOpenCheckboxDialog(false);
      }
    };

    if (openCheckboxDialog) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openCheckboxDialog]);

  return (
    <>
      {(policyDetails && policyDetails?.isSign) ||
      isPolicyDetailsLoading ||
      Object.keys(policyDetails).length === 0 ? (
        <Spinner />
      ) : (
        <div className={`${styles.container} ${isMobile ? styles.mobile : ''}`}>
          <p
            className={styles.heading}
            dangerouslySetInnerHTML={{
              __html: termsAndConditionsId?.pageHeader,
            }}
          ></p>
          <div
            className={`${styles.scroll} ${isMobile ? styles.mobile : ''}`}
            ref={scrollContainerRef}
            onScroll={handleScroll}
            style={{
              maxHeight: '350px',
              overflowY: 'scroll',
              padding: '10px',
            }}
          >
            <p
              className={`${styles.card} ${isMobile ? styles.mobile : ''}`}
              dangerouslySetInnerHTML={{
                __html: termsAndConditionsId?.termsAndConditionsDetails.replace(
                  /<p>/g,
                  '<p style="font-family: Montserrat-light;">'
                ),
              }}
            />
          </div>
          <div
            className={`${styles.checkbox} ${isMobile ? styles.mobile : ''}`}
            ref={checkboxContainerRef}
          >
            <Checkbox
              inputRef={checkboxRef}
              onClick={handleCheckboxClick}
              onChange={handleCheckboxChange}
              checked={isTabsEnabled}
              size={isMobile ? 'large' : 'large'}
              sx={{
                '& .MuiSvgIcon-root': {
                  color: isScrolledToBottom === true ? 'var(--orange-color)' : 'none',
                },
                '&.Mui-checked': {
                  color: 'var(--orange-color)',
                },
              }}
            />
            <label
              className={`${styles.label} ${isMobile ? styles.mobile : ''} `}
              htmlFor="myCheckbox"
            >
              I, {firstName} {lastName}, agree to the FITNESS SF{' '}
              <strong>Membership Agreement</strong>,{' '}
              <a
                href="https://www.fitnesssf.com/terms-of-service"
                className={styles.link}
                target="_blank"
              >
                Terms Of Service
              </a>
              ,{' '}
              <a
                href="https://www.fitnesssf.com/privacy-policy"
                className={styles.link}
                target="_blank"
              >
                Privacy Policy
              </a>
              , and I am at least 18 years of age.
            </label>
          </div>

          <div className={styles.innerCard}>
            <div className={styles.tabs}>
              {/* Tab for "TYPE SIGNATURE" */}
              {activeTab === 'type' ? (
                <button
                  onClick={() => isTabsEnabled && setActiveTab('type')}
                  className={!isTabsEnabled ? styles.disableTab : styles.tab}
                  disabled={!isTabsEnabled}
                >
                  <img src={keyboard} alt="icon" className={styles.logo} />
                  TYPE SIGNATURE
                </button>
              ) : (
                <p
                  className={styles.inactiveTab}
                  onClick={() => isTabsEnabled && setActiveTab('type')}
                  disabled={!isTabsEnabled}
                >
                  TYPE SIGNATURE
                </p>
              )}

              {/* Tab for "DRAW SIGNATURE" */}
              {activeTab === 'draw' ? (
                <button
                  onClick={() => {
                    isTabsEnabled && setActiveTab('draw');
                  }}
                  disabled={!isTabsEnabled}
                  className={styles.tab}
                >
                  {activeTab === 'draw' && (
                    <img src={scribble} alt="icon" className={styles.logo} />
                  )}
                  DRAW SIGNATURE
                </button>
              ) : (
                <p
                  className={!isTabsEnabled ? styles.disableTabHover : styles.inactiveTab}
                  disabled={!isTabsEnabled}
                  onClick={() => {
                    isTabsEnabled && setActiveTab('draw');
                  }}
                >
                  DRAW SIGNATURE
                </p>
              )}
            </div>

            {/* Content for each tab */}
            {activeTab === 'type' ? (
              <div className={styles.contentContainer}>
                <p className={styles.inputLabel}>Type Signature</p>
                <input
                  type="text"
                  value={typedSignature}
                  onChange={handleSignature}
                  className={styles.input}
                  disabled={!isTabsEnabled}
                  onPaste={e => {
                    e.preventDefault();
                    alert('Pasting is disabled for this field.');
                  }}
                />
                <div
                  className={styles.typeSignatureBox}
                  ref={typesSignatureBoxRef}
                  key={typedSignature + forceRender}
                >
                  {typedSignature}
                </div>
                {/* Hidden off-screen canvas */}
                <canvas ref={offscreenCanvasRef} style={{ display: 'none' }} />
              </div>
            ) : (
              <div className={styles.contentContainer}>
                <p className={styles.inputLabel}>Draw Signature</p>
                <div className={styles.drawSignatureBox}>
                  <SignatureCanvas
                    ref={signedCanvasRef}
                    penColor="black"
                    canvasProps={{
                      className: styles.signatureCanvas,
                    }}
                    onEnd={() => {
                      // Save the drawn signature whenever it changes
                      const originalCanvas = signedCanvasRef.current.getTrimmedCanvas();
                      const originalWidth = originalCanvas.width;
                      const originalHeight = originalCanvas.height;

                      // Set the target width (600) and calculate proportional height
                      const targetWidth = 600;
                      const targetHeight = (originalHeight / originalWidth) * targetWidth;

                      // Create a new canvas for resizing
                      const resizeCanvas = document.createElement('canvas');
                      resizeCanvas.width = targetWidth;
                      resizeCanvas.height = targetHeight;

                      const ctx = resizeCanvas.getContext('2d');
                      ctx.drawImage(originalCanvas, 0, 0, targetWidth, targetHeight);

                      // Get the resized signature as a data URL
                      const resizedImageURL = resizeCanvas.toDataURL('image/png');

                      setDrawSignImage(resizedImageURL);
                    }}
                  />
                </div>
              </div>
            )}

            <div className={styles.contentContainer}>
              <p className={styles.clear} onClick={handleClear}>
                x clear
              </p>
              <p className={`${styles.label} ${isMobile ? styles.mobile : ''} `}>
                By clicking "Sign" I, {firstName} {lastName}, a FITNESS SF Member, agree
                that this is a legal representation of my signature.
              </p>
              <div className={styles.buttonWrapper}>
                <button
                  onClick={handleSignInClick}
                  className={
                    !isTabsEnabled ||
                    (activeTab === 'type' && !typedSignature.trim()) ||
                    (activeTab === 'draw' && !drawSignImage) ||
                    isSignInloading ||
                    isSignClicked
                      ? styles.disableSubmitButton
                      : styles.submitButton
                  }
                  disabled={
                    !isTabsEnabled ||
                    (activeTab === 'type' && !typedSignature.trim()) ||
                    (activeTab === 'draw' && !drawSignImage) ||
                    isSignInloading ||
                    isSignClicked
                  }
                >
                  {isSignInloading ? (
                    <CircularProgress
                      size={20}
                      style={{ color: '#fe5000', marginTop: '5px' }}
                    />
                  ) : (
                    'Sign'
                  )}
                </button>
              </div>
            </div>
          </div>
          <Dialog
            open={openThanksDialog}
            fullScreen
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <>
              <div className={styles.modalContainer}>
                <div
                  className={`${styles.headerContainer} ${isMobile ? styles.mob : null}`}
                >
                  <div>
                    <img
                      src={fsfLogo}
                      alt="logo"
                      className={`${styles.headerLogo} ${isMobile ? styles.mob : null}`}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.mainContent}>
                <p className={styles.text}>
                  Thank you for accepting our <br />
                  Terms and Conditions.
                </p>
                <p className={styles.text1}>
                  Please return to the {isSmallMobile ? <br /> : ''}
                  <a
                    href={`${portalUrl}/login`}
                    className={styles.mainLink}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    FITNESS SF App
                  </a>{' '}
                  {isSmallMobile ? <br /> : ''}
                  to continue.
                </p>
              </div>
            </>
          </Dialog>
          {Object.keys(policyDetails).length !== 0 && openScrollGuidanceBubble && (
            <div className={styles.overlay}>
              <div className={styles.popover}>
                <p className={styles.popoverText}>
                  Scroll all the way down the Policy window.
                </p>
                <img src={caretDoubleDown} alt="icon" className={styles.popoverLogo} />
              </div>
            </div>
          )}
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            disableScrollLock
            onClose={handleClosePopover}
            TransitionProps={{ timeout: 0 }}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            sx={{
              '& .MuiPaper-root': { borderRadius: '10px', marginLeft: '5px' },
              '& .MuiBackdrop-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
              },
            }}
          >
            <div className={styles.checkboxDialog}>
              <img src={warningCircle} alt="icon" className={styles.popoverLogo} />
              <p className={styles.checkboxDialogText}>
                Must scroll all the way down the Policy window to activate checkbox.
              </p>
            </div>
          </Popover>
        </div>
      )}
    </>
  );
};

export default PolicyScreen;
